import { useMemo, useState, useCallback } from 'react';

export const useShowMore = <T>(
  data?: T[],
  initialSize = 20,
  increment = 20
) => {
  const [visibleCount, setVisibleCount] = useState(initialSize);

  const visibleData = useMemo(
    () => data?.slice(0, visibleCount),
    [data, visibleCount]
  );

  const onShowMore = useCallback(() => {
    setVisibleCount((prev) => Math.min(prev + increment, data?.length ?? 0));
  }, [increment, data?.length]);

  const hasMore = useMemo(
    () => visibleCount < (data?.length ?? 0),
    [visibleCount, data?.length]
  );

  return { hasMore, onShowMore, visibleData, totalCount: data?.length ?? 0 };
};
